import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiLogOut, FiX, FiMenu } from "react-icons/fi";
import auth from "../../redux/actions/auth";
import bakeliImg from "../../assets/images/bakeli.png";

const DashboardHeader = ({ toggleSidebar, isSidebarOpen }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await auth.logout(navigate);
    } catch (error) {
      // console.error("Erreur lors de la déconnexion :", error);
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("currentUser");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  // Contrôleur pour définir le rôle
  const getRoleTitle = () => {
    if (!user) return "UTILISATEUR";
    if (user.is_admin) return "ADMIN";
    if (user.is_coach) return "COACH";
    return "UTILISATEUR";
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-4 md:px-6 py-3 bg-white shadow-sm w-full">
      {/* Logo + Titre */}
      <div className="flex items-center gap-2 md:gap-4">
        {/* Bouton toggle pour mobile */}
        <button
           className="md:hidden p-2 rounded-lg hover:bg-gray-100"
           onClick={toggleSidebar}
      //     className={`fixed top-0 left-0 h-full bg-teal-700 text-white z-40 transform transition-transform duration-300
      // ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} 
      // md:translate-x-0 
      // ${isSidebarOpen ? "w-16 md:w-64" : "w-16 md:w-64"}`}
         >
          {isSidebarOpen ? (
            <FiX className="w-6 h-6 text-gray-700" />
          ) : (
            <FiMenu className="w-6 h-6 text-gray-700" />
          )}
        </button>
        <img src={bakeliImg} alt="Bakeli Logo" className="h-8 md:h-10 w-auto " />
        <h1 className="hidden sm:block text-base md:text-lg font-bold mb-0 mt-2">
          <span className="text-orange-400">TRAINING</span>{" "}
          <span className="text-teal-600">{getRoleTitle()}</span>
        </h1>
      </div>

      {/* Champ de recherche (caché sur mobile, visible à partir de md)
      <div className="hidden md:flex flex-1 mx-6">
        <input
          type="text"
          placeholder="Rechercher Bakelistes"
          className="w-[60%] m-auto border-2 border-teal-500 text-gray-600 px-6 py-2 rounded-full focus:outline-none placeholder-gray-400"
        />
      </div> */}

      {/* Icône de recherche visible seulement sur mobile */}
      <button className="md:hidden text-gray-600 text-1xl">
        <input
          type="text"
          placeholder="Rechercher Bakelistes"
          className="w-[60%] border-2 border-teal-500 text-gray-600 px-4 py-2 rounded-full focus:outline-none placeholder-gray-400"
        />
      </button>

      {/* Profil + Déconnexion */}
      <div className="flex items-center gap-4 md:gap-4">
        <div className="relative">
          <img
            src="https://randomuser.me/api/portraits/men/32.jpg"
            alt="User Avatar"
            className="w-8 h-8 xs:w-6 xs:h-6 md:w-10 md:h-10 rounded-full  ring-2 ring-orange-400 object-cover"
          />
        </div>
        <span className="hidden sm:block text-sm font-medium text-black">
          {user ? `${user.firstName} ${user.lastName}` : "Utilisateur"}
        </span>
        <button
          onClick={handleLogout}
          className="bg-teal-600 text-white p-1.5 rounded-full hover:bg-teal-500 transition duration-200"
        >
          <FiLogOut />
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;
